import { render, staticRenderFns } from "./Rakam.vue?vue&type=template&id=6410a497&scoped=true&"
import script from "./Rakam.vue?vue&type=script&lang=js&"
export * from "./Rakam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6410a497",
  null
  
)

export default component.exports